'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type HTMLAttributes, type PropsWithChildren, useContext } from 'react';
import * as Compact from '../CompactTable/Table';
import * as Large from '../LargeTable/Table';
export const TableVariantContext = createContext<'large' | 'compact' | 'compact-filter'>('large');
export const useTableVariant = () => {
  return useContext(TableVariantContext);
};
export const Table = t0 => {
  const $ = _c(13);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      tableVariant: t1,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const tableVariant = t1 === undefined ? "large" : t1;
  let t2;
  if ($[5] !== children || $[6] !== className || $[7] !== props || $[8] !== tableVariant) {
    t2 = tableVariant === "compact" || tableVariant === "compact-filter" ? <Compact.Table tableVariant={tableVariant} className={className} {...props}>{children}</Compact.Table> : <Large.Table {...props}>{children}</Large.Table>;
    $[5] = children;
    $[6] = className;
    $[7] = props;
    $[8] = tableVariant;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t2 || $[11] !== tableVariant) {
    t3 = <TableVariantContext.Provider value={tableVariant}>{t2}</TableVariantContext.Provider>;
    $[10] = t2;
    $[11] = tableVariant;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};

/**
 * Sticky header is only available for large table variant.
 * @param position - "sticky" | "default"
 * @default "default"
 */
export interface TableTheadProps extends PropsWithChildren {
  position?: 'sticky' | 'default';
}
export const Thead = t0 => {
  const $ = _c(5);
  const {
    children,
    position: t1
  } = t0;
  const position = t1 === undefined ? "default" : t1;
  const tableVariant = useTableVariant();
  if (tableVariant === "compact" || tableVariant === "compact-filter") {
    let t2;
    if ($[0] !== children) {
      t2 = <Compact.Thead>{children}</Compact.Thead>;
      $[0] = children;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== children || $[3] !== position) {
    t2 = <Large.Thead position={position}>{children}</Large.Thead>;
    $[2] = children;
    $[3] = position;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const Tbody = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const tableVariant = useTableVariant();
  if (tableVariant === "compact" || tableVariant === "compact-filter") {
    let t1;
    if ($[0] !== children || $[1] !== tableVariant) {
      t1 = <Compact.Tbody tableVariant={tableVariant}>{children}</Compact.Tbody>;
      $[0] = children;
      $[1] = tableVariant;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== children) {
    t1 = <Large.Tbody>{children}</Large.Tbody>;
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export const Tr = props => {
  const $ = _c(4);
  const tableVariant = useTableVariant();
  if (tableVariant === "compact" || tableVariant === "compact-filter") {
    let t0;
    if ($[0] !== props) {
      t0 = <Compact.Tr {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <Large.Tr {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export const Td = t0 => {
  const $ = _c(15);
  const {
    children,
    href,
    width,
    colSpan,
    prefetch,
    onNavigate
  } = t0;
  const tableVariant = useTableVariant();
  if (tableVariant === "compact" || tableVariant === "compact-filter") {
    let t1;
    if ($[0] !== children || $[1] !== colSpan || $[2] !== href || $[3] !== onNavigate || $[4] !== prefetch || $[5] !== tableVariant || $[6] !== width) {
      t1 = <Compact.Td tableVariant={tableVariant} width={width} href={href} prefetch={prefetch} colSpan={colSpan} onNavigate={onNavigate}>{children}</Compact.Td>;
      $[0] = children;
      $[1] = colSpan;
      $[2] = href;
      $[3] = onNavigate;
      $[4] = prefetch;
      $[5] = tableVariant;
      $[6] = width;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  let t1;
  if ($[8] !== children || $[9] !== colSpan || $[10] !== href || $[11] !== onNavigate || $[12] !== prefetch || $[13] !== width) {
    t1 = <Large.Td href={href} width={width} prefetch={prefetch} colSpan={colSpan} onNavigate={onNavigate}>{children}</Large.Td>;
    $[8] = children;
    $[9] = colSpan;
    $[10] = href;
    $[11] = onNavigate;
    $[12] = prefetch;
    $[13] = width;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
};